import { IconButton, IconButtonProps } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { IOverlayLoaderStore } from '../OverlayLoader.store';

interface IProps extends IconButtonProps {
  id?: string;
  loaderKey: string;
  disabled: boolean;
  title: string;
  onClick(): void;
}

export const AnnotationNavigationIconButton = observer((props: PropsWithChildren<IProps>): ReactElement => {
  const { loaderKey, ...rest } = props;
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);

  const isLoading = !!loaderKey && overlayLoaderStore.isSpinnerVisible(loaderKey);

  return (
    <IconButton
      {...rest}
      loading={isLoading}
    />
  );
});
